import LeadsAPI from '../../api/leads';
import {
  apiParamsWithoutCacheControl,
  readCrmCache,
  shouldBypassCrmCache,
  writeCrmCache,
} from '../../helper/crmCache';

const CACHE_TTL = 60 * 1000;

const MUTATIONS = {
  SET_LEADS:       'LEADS_SET_LEADS',
  SET_FETCHING:    'LEADS_SET_FETCHING',
  SET_SUBMITTING:  'LEADS_SET_SUBMITTING',
  SET_ERROR:       'LEADS_SET_ERROR',
};

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isSubmitting: false,
  },
  error: null,
};

const getters = {
  getLeads:        $state => $state.records,
  getLeadsUIFlags: $state => $state.uiFlags,
  getLeadById:     $state => id => $state.records.find(r => r.id === Number(id)),
};

const actions = {
  fetchLeads: async ({ commit }, params = {}) => {
    const apiParams = apiParamsWithoutCacheControl(params);
    const cached = shouldBypassCrmCache(params)
      ? null
      : readCrmCache('leads.all', apiParams, CACHE_TTL);

    if (cached) {
      commit(MUTATIONS.SET_LEADS, cached);
      return;
    }

    commit(MUTATIONS.SET_FETCHING, true);
    commit(MUTATIONS.SET_ERROR, null);
    try {
      const { data } = await LeadsAPI.getLeads(apiParams);
      const leads = data.leads ?? [];
      commit(MUTATIONS.SET_LEADS, leads);
      writeCrmCache('leads.all', apiParams, leads);
    } catch (error) {
      commit(MUTATIONS.SET_ERROR, error.message);
    } finally {
      commit(MUTATIONS.SET_FETCHING, false);
    }
  },

  fetchMyLeads: async ({ commit }, params = {}) => {
    const apiParams = apiParamsWithoutCacheControl(params);
    const cached = shouldBypassCrmCache(params)
      ? null
      : readCrmCache('leads.mine', apiParams, CACHE_TTL);

    if (cached) {
      commit(MUTATIONS.SET_LEADS, cached);
      return;
    }

    commit(MUTATIONS.SET_FETCHING, true);
    commit(MUTATIONS.SET_ERROR, null);
    try {
      const { data } = await LeadsAPI.getMyLeads(apiParams);
      const leads = data.leads ?? [];
      commit(MUTATIONS.SET_LEADS, leads);
      writeCrmCache('leads.mine', apiParams, leads);
    } catch (error) {
      commit(MUTATIONS.SET_ERROR, error.message);
    } finally {
      commit(MUTATIONS.SET_FETCHING, false);
    }
  },

  bulkAssign: async ({ commit }, payload) => {
    commit(MUTATIONS.SET_SUBMITTING, true);
    try {
      await LeadsAPI.bulkAssign(payload);
    } finally {
      commit(MUTATIONS.SET_SUBMITTING, false);
    }
  },

  bulkRedistribute: async ({ commit }, payload) => {
    commit(MUTATIONS.SET_SUBMITTING, true);
    try {
      const { data } = await LeadsAPI.bulkRedistribute(payload);
      return data;
    } finally {
      commit(MUTATIONS.SET_SUBMITTING, false);
    }
  },

  redistribute: async ({ commit }, payload) => {
    commit(MUTATIONS.SET_SUBMITTING, true);
    try {
      const { data } = await LeadsAPI.redistribute(payload);
      return data;
    } finally {
      commit(MUTATIONS.SET_SUBMITTING, false);
    }
  },
};

const mutations = {
  [MUTATIONS.SET_LEADS]($state, leads) {
    $state.records = leads;
  },
  [MUTATIONS.SET_FETCHING]($state, value) {
    $state.uiFlags.isFetching = value;
  },
  [MUTATIONS.SET_SUBMITTING]($state, value) {
    $state.uiFlags.isSubmitting = value;
  },
  [MUTATIONS.SET_ERROR]($state, error) {
    $state.error = error;
  },
};

export default { state, getters, actions, mutations };
